<template>
  <div class="sliderRoot">
    <div class="swContainer">
      <div v-show="page == 0" class="swIcon icon1"></div>
      <div v-show="page == 1" class="swIcon icon2"></div>
      <div v-show="page == 2" class="swIcon icon3"></div>
      <div v-show="page == 3" class="swIcon icon4"></div>

      <div v-if="this.page == 0" class="leftBtn" @click="goPre"></div>
      <div v-else class="leftBtnLight" @click="goPre"></div>

      <div v-if="this.page != 3" class="rightBtn" @click="goNext"></div>
      <div v-else class="rightBtnDark" @click="goNext"></div>
      <Swiper ref="swiper" class="sw" @transtionend="getNum">
        <Slide>
          <div class="swContent">
            <span class="swSubTitle">专业团队。</span>
            时空视界智能科技（福建）有限公司是由国内知名企业家、投资⼈、海外留学⼈员和创新创业团队共同创⽴的⾼新技术企业。
          </div>
        </Slide>
        <Slide>
          <div class="swContent">
            <span class="swSubTitle">技术成熟。</span>
            经历长期的技术沉淀，促进产品不断更新迭代。
          </div>
        </Slide>
        <Slide>
          <div class="swContent">
            <span class="swSubTitle">优质服务。</span>
            快速提供定制化解决方案，为客户提供最好的产品。
          </div>
        </Slide>
        <Slide>
          <div class="swContent">
            <span class="swSubTitle">公司愿景。</span>
            时空视界希望能成为 3D-GIS 三维地理信息技术和⼤数据可视化技术的领先者，成为全球各⾏业智慧管理平台的主要供应商，我们坚信科技将为您创造巨⼤价值。
          </div>
        </Slide>
      </Swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, Slide } from 'vue-swiper-component'
export default {
  name: 'AboutUsSwiper',
  components: {
    Swiper,
    Slide,
  },
  data() {
    return {
      page: 0,
    }
  },
  methods: {
    getNum(page) {
      console.log(page)
      this.page = page
    },
    goPre() {
      this.$refs.swiper.prevSlide()
    },
    goNext() {
      this.$refs.swiper.nextSlide()
    },
  },
}
</script>
<style>
.wh_show_bgcolor {
  background: #ffffff !important;
}
.wh_indicator {
  bottom: -46px;
}
</style>
<style scoped="scoped">
.icon1 {
  background-image: url(../assets/aboutUs/icon_team.png);
}
.icon2 {
  background-image: url(../assets/aboutUs/icon_technology.png);
}
.icon3 {
  background-image: url(../assets/aboutUs/icon_service.png);
}
.icon4 {
  background-image: url(../assets/aboutUs/icon_road.png);
}
.swIcon {
  width: 49px;
  height: 40px;
  position: absolute;
  margin-left: 120px;
  margin-top: -50px;
  background-size: 49px 40px;
}
.swSubTitle {
  font-weight: bold;
  /* font-family: SourceHanSansKBold-Bold; */
}
.swContent {
  font-size: 24px;
  /* font-family: SourceHanSansK-Regular; */
  color: #e9e9e9;
  line-height: 36px;
  letter-spacing: 1px;
  text-align: left;
}

.swContainer {
  padding-top: 50px;
  margin: 0 auto;
  display: inline-block;
  width: 700px;
  /* padding-top: 50px;
		margin: 0 auto; */
}
.sw {
  margin-left: 120px !important;
  width: 450px;
  height: 270px;
  padding-top: 20px;
}
.rightBtnDark {
  background-image: url(../assets/aboutUs/icon_right_companypage_dark.png);
  background-size: 29.27px 50px;
  width: 29.27px;
  height: 50px;
  position: absolute;
  margin-left: 660px;
  z-index: 3;
}
.leftBtnLight {
  background-image: url(../assets/aboutUs/icon_left_companypage_light.png);
  background-size: 29.27px 50px;
  width: 29.27px;
  height: 50px;
  position: absolute;
  margin-left: 0px;
  z-index: 3;
}
.rightBtn {
  background-image: url(../assets/aboutUs/icon_right_companypage.png);
  background-size: 29.27px 50px;
  width: 29.27px;
  height: 50px;
  position: absolute;
  margin-left: 660px;
  z-index: 3;
}
.leftBtn {
  background-image: url(../assets/aboutUs/icon_left_companypage.png);
  background-size: 29.27px 50px;
  width: 29.27px;
  height: 50px;
  position: absolute;
  margin-left: 0px;
  z-index: 3;
}
.sliderRoot {
  width: 690px;
  height: 345px;
  background-color: #1d1d20;
}
</style>
